import admin from "./reducer";

export default admin;
